import { render, staticRenderFns } from "./ExtendedFamilyList.vue?vue&type=template&id=147eb61f"
import script from "./ExtendedFamilyList.vue?vue&type=script&lang=js"
export * from "./ExtendedFamilyList.vue?vue&type=script&lang=js"
import style0 from "./ExtendedFamilyList.vue?vue&type=style&index=0&id=147eb61f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports